/* RESPONSIBLE TEAM: team-standalone */

import type { ConversationExtractionRowData } from '../definitions';
import type ZendeskPlatform from '../../zendesk';

export default class ZendeskConversationExtractionRow implements ConversationExtractionRowData {
  private platform: ZendeskPlatform;

  constructor(platform: ZendeskPlatform) {
    this.platform = platform;
  }

  get icon() {
    return 'zendesk' as const;
  }

  get title() {
    if (this.platform.zendeskConfig?.isConnected) {
      return `${this.platform.zendeskConfig?.subdomain}.zendesk.com`;
    }
    return this.platform.intl.t(
      'knowledge-hub.overview.sections.conversation-extraction.rows.active.title.zendesk',
    );
  }
}
